var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.63636 5.99997C1.33512 5.99997 1.09091 6.24418 1.09091 6.54542V10.3636C1.09091 10.6648 1.33512 10.9091 1.63636 10.9091H9.27273C9.57397 10.9091 9.81818 10.6648 9.81818 10.3636V6.54542C9.81818 6.24418 9.57397 5.99997 9.27273 5.99997H1.63636ZM0 6.54542C0 5.64168 0.732625 4.90906 1.63636 4.90906H9.27273C10.1765 4.90906 10.9091 5.64168 10.9091 6.54542V10.3636C10.9091 11.2673 10.1765 12 9.27273 12H1.63636C0.732625 12 0 11.2673 0 10.3636V6.54542Z",
    fill: "#7763AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45437 1.09091C4.87571 1.09091 4.32076 1.32078 3.91159 1.72995C3.50242 2.13912 3.27255 2.69407 3.27255 3.27273V5.45455C3.27255 5.75579 3.02834 6 2.7271 6C2.42585 6 2.18164 5.75579 2.18164 5.45455V3.27273C2.18164 2.40475 2.52644 1.57232 3.1402 0.95856C3.75396 0.344804 4.58639 0 5.45437 0C6.32235 0 7.15478 0.344804 7.76854 0.95856C8.38229 1.57232 8.7271 2.40475 8.7271 3.27273V5.45455C8.7271 5.75579 8.48289 6 8.18164 6C7.88039 6 7.63619 5.75579 7.63619 5.45455V3.27273C7.63619 2.69407 7.40632 2.13912 6.99715 1.72995C6.58798 1.32078 6.03302 1.09091 5.45437 1.09091Z",
    fill: "#7763AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.22899ce74f2c18fb0c7cb4bb057f7deb.svg";
export { ForwardRef as ReactComponent };